"use strict";

/* A service / model */
_BannerFlowApp.factory("LandingPage", function ($resource, AuthInfo) {
    return $resource(
        "",
        {
            id: "@id"
        },
        {
            duplicate: {
                method: "POST",
                url: "{0}/api/brands/{1}/landingPages/:id/duplicate".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            },
            publish: {
                method: "POST",
                url: "{0}/api/brands/{1}/landingPages/:id/publish".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformRequest: {
                    body: function () {
                        return null;
                    }
                }
            },
            status: {
                method: "GET",
                isArray: false,
                url: "{0}/api/b2landingpage/{1}/{2}/:id/getProperties".format(
                    LANDING_PAGE_URL,
                    AuthInfo.LoggedInUser.currentAccount.slug,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformResponse: function (data, headers, statusCode) {
                    const response = {};
                    const result = statusCode == 200 ? JSON.parse(data) : {};
                    response.data = result.status;
                    response.headers = headers();

                    return response;
                }
            },
            create: {
                method: "POST",
                url: "{0}/api/brands/{1}/landingPages".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                )
            },
            meta: {
                method: "POST",
                url: "{0}/api/brands/{1}/folders/landingpages/search".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformResponse: function (data, headers, statusCode) {
                    const response = {};
                    response.data = statusCode == 200 ? JSON.parse(data) : {};
                    response.headers = headers();

                    return response;
                }
            },
            state: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/state".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformRequest: {
                    body: function (data, headers) {
                        var landingPages = _.pluck(
                            _.filter(data.items, function (i) {
                                return !i.isFolder;
                            }),
                            "id"
                        );

                        var folders = _.pluck(
                            _.filter(data.items, function (i) {
                                return i.isFolder;
                            }),
                            "id"
                        );

                        data = JSON.stringify({
                            landingPages: landingPages,
                            folders: folders,
                            state: data.state
                        });

                        return data;
                    }
                }
            },
            lock: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/lock".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformRequest: {
                    body: function (data, headers) {
                        var landingPages = _.pluck(
                            _.filter(data.items, function (i) {
                                return !i.isFolder;
                            }),
                            "id"
                        );

                        data = JSON.stringify({
                            landingPages: landingPages,
                            lock: data.lock
                        });

                        return data;
                    }
                }
            },
            drop: {
                method: "PUT",
                url: "{0}/api/brands/{1}/folders/move".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                transformRequest: {
                    body: function (data, headers) {
                        var landingPages = _.pluck(
                            _.filter(data.items, function (i) {
                                return !i.isFolder;
                            }),
                            "id"
                        );

                        var folders = _.pluck(
                            _.filter(data.items, function (i) {
                                return i.isFolder;
                            }),
                            "id"
                        );

                        data = JSON.stringify({
                            landingPages: landingPages,
                            folders: folders,
                            folderToMoveTo: data.folder
                        });

                        return data;
                    }
                }
            }
        }
    );
});
